/**
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
export const GENERIC_USER_ERROR = "USR.CWXFR0130E";
export const EXPIRED_ACTIVITY_TOKEN_ERROR = "CWXBB1011E";
export const INVALID_COOKIE_ERROR_KEY = "_ERR_INVALID_COOKIE";
export const INVALID_COOKIE_ERROR_CODE = "CMN1039E";
export const SESSION_TIMEOUT_ERROR = "sessionTimeout";
export const SESSION_INVALID_ERROR = "sessionInvalid";
export const ACCOUNT_LOCKOUT_ERROR = "2490";
export const CART_LOCKED = "_ERR_ORDER_IS_LOCKED";
export const PASSWORD_EXPIRED = "_ERR_PASSWORD_EXPIRED";
export const PASSWORD_EXPIRED_ERR_CODE = "2170";
export const ACCOUNT_NOT_ACTIVATED = "2450";
export const PARTIAL_AUTHENTICATION_ERROR_CODE = "CWXFR0222E";
export const PARTIAL_AUTHENTICATION_ERROR_KEY =
  "ERR_PARTIAL_AUTHENTICATION_NOT_ALLOWE";
export const CMC_SESSION_ERROR_KEY = "CMC_RELOGON";
export const ACTIVITY_TOKEN_ERROR_KEY = "_ERR_ACTIVITY_TOKEN";
export const ACTIVITY_TOKEN_ERROR_CODE = "CWXBB1103E";
